<template>
  <el-dialog
    ref="dialogRef"
    append-to-body
    :visible="visible"
    class="page-dialog center-dialog-no-footer member-detail-v2-dialog"
    width="80%"
    :close-on-click-modal="false"
    @close="emitUpdateVisible(false)"
  >
    <template #title>
      <div class="v2-title">
        <MemberUidHeader :username="userInfo.username" :uid="userInfo.uid" :vip-level="userInfo.vip_level" />
      </div>
    </template>

    <div class="v2-body">
      <el-tabs v-model="activeTab" class="page-tabs" :tab-position="'top'">
        <el-tab-pane label="会员概览" name="overview">
          <ManageOverviewTabV2
            v-show="activeTab === 'overview'"
            :uid="Number(memberUid) || 0"
            :user-info="userInfo"
            @status-changed="reload"
            @open-bet-history="openBetHistory"
          />
        </el-tab-pane>
        <!-- <el-tab-pane label="个人资料" name="personalInfo">
          <el-empty description="开发中"></el-empty>
        </el-tab-pane> -->
        <el-tab-pane label="提现账号" name="withdrawAccount">
          <ManageWithdrawAccountTabV2
            v-show="activeTab === 'withdrawAccount'"
            :uid="Number(memberUid)"
            :target-info="targetInfo"
            :is-active="activeTab === 'withdrawAccount'"
          />
        </el-tab-pane>
        <el-tab-pane label="账户交易" name="accountTrade">
          <ManageAccountChangeTab
            v-show="activeTab === 'accountTrade'"
            :uid="Number(memberUid)"
            :is-active="activeTab === 'accountTrade'"
          />
        </el-tab-pane>
        <el-tab-pane label="投注统计" name="betStats">
          <ManageTransactionInfoTabV2
            v-show="activeTab === 'betStats'"
            :target-info="targetInfo"
            :is-active="activeTab === 'betStats'"
          />
        </el-tab-pane>
        <el-tab-pane label="会员日志" name="memberLogs">
          <ManageMemberLogsTabV2
            v-show="activeTab === 'memberLogs'"
            :target-info="targetInfo"
            :is-active="activeTab === 'memberLogs'"
          />
        </el-tab-pane>
        <!-- <el-tab-pane label="登录设备" name="loginDevices">
          <el-empty description="开发中"></el-empty>
        </el-tab-pane>
        <el-tab-pane label="账号同关联" name="accountRelations">
          <el-empty description="开发中"></el-empty>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import { getCurrentInstance, ref, watch, computed, inject } from 'vue'
import ManageOverviewTabV2 from './ManageOverviewTabV2.vue'
import MemberUidHeader from './v2/MemberUidHeader.vue'
import ManageAccountChangeTab from './ManageAccountChangeTab.vue'
import ManageMemberLogsTabV2 from './v2/tabs/ManageMemberLogsTabV2.vue'
import ManageWithdrawAccountTabV2 from './v2/tabs/ManageWithdrawAccountTabV2.vue'
import ManageTransactionInfoTabV2 from './v2/tabs/ManageTransactionInfoTabV2.vue'

export default {
  name: 'MemberDetailDialogV2',
  components: {
    ManageOverviewTabV2,
    MemberUidHeader,
    ManageAccountChangeTab,
    ManageTransactionInfoTabV2,
    ManageMemberLogsTabV2,
    ManageWithdrawAccountTabV2,
  },
  emits: ['update:visible', 'closed'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    memberUid: {
      type: [Number, String],
      default: 0,
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    defaultDetailTabType: {
      type: String,
      default: 'overview',
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const dialogRef = ref(null)
    const activeTab = ref(props.defaultDetailTabType)

    const targetInfo = computed(() => ({
      username: props.userInfo?.username || '',
      uid: props.memberUid,
      vip_level: props.userInfo?.vip_level || 0,
    }))

    const emitUpdateVisible = val => {
      emit('update:visible', val)
    }

    const statusChange = ref(false)

    const reload = () => {
      const MEMBER_INFO_PROVIDER = inject('MEMBER_INFO_PROVIDER')
      console.log('MEMBER_INFO_PROVIDER', MEMBER_INFO_PROVIDER)
      if (MEMBER_INFO_PROVIDER) {
        MEMBER_INFO_PROVIDER.changeStatus = true
        statusChange.value = true
      }
    }

    const handleClosed = () => {
      activeTab.value = props.defaultDetailTabType
      statusChange.value = false
    }

    const openBetHistory = () => {
      activeTab.value = 'betStats'
    }

    watch(
      () => props.visible,
      v => {
        if (v) {
          activeTab.value = props.defaultDetailTabType
          proxy?.$nextTick?.(() => {
            const body = dialogRef.value?.$el?.querySelector?.('.el-dialog__body')
            if (body) body.scrollTop = 0
          })
        }
      },
      { immediate: true }
    )

    return {
      dialogRef,
      activeTab,
      targetInfo,
      emitUpdateVisible,
      openBetHistory,
      handleClosed,
      reload,
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.v2-body {
  height: 600px;
  overflow-y: auto;
}
</style>
